import { render, staticRenderFns } from "./UserEducation.vue?vue&type=template&id=708f7da1"
import script from "./UserEducation.js?vue&type=script&lang=js&external"
export * from "./UserEducation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports